import React, { Component } from 'react'
import Search from '../search'
import { Link } from 'react-router-dom'

class Header extends Component {
  constructor(props) {
    super(props)
    this.handleScroll = this.handleScroll.bind(this)
    this.state = {
      hidden: false,
      scroll: window.scrollY || 0
    }
  }

  componentDidMount() {
    document.addEventListener('scroll', this.handleScroll)
  }

  componentWillUnmount() {
    document.removeEventListener('scroll', this.handleScroll)
  }

  handleScroll() {
    const { scrollY } = window
    const { scroll } = this.state
    const searchOpen = this.refs.header.querySelector('.search-results')
    const hidden = scrollY > scroll

    if (searchOpen) {
      return
    }

    this.setState({ scroll: Math.max(scrollY, 20), hidden })
  }

  render() {
    const { hidden, scroll } = this.state

    return window === window.top ? (
      <header
        ref="header"
        className={['header', hidden && 'hidden', scroll > 20 && 'scrolled']
          .filter(Boolean)
          .join(' ')}>
        <Link className="athena-holder" to="/">
        <div className="athena">
        <svg viewBox="0 0 24 24" fill="#777">
    <path d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"></path>
</svg>
</div>
        </Link>
        <Search />
      </header>
    ) : null
  }
}

export default Header



// WEBPACK FOOTER //
// ./src/components/header/index.js